export type PortalOfferStatus = 'submitted' | 'draft' | 'pending';

export function derivePortalOfferStatus(
  rfqPublicSubmittedAt: string | null | undefined,
  rfqPortalLastSavedAt: string | null | undefined,
): PortalOfferStatus {
  if (rfqPublicSubmittedAt) return 'submitted';
  if (rfqPortalLastSavedAt) return 'draft';
  return 'pending';
}

export function portalOfferStatusLabel(s: PortalOfferStatus): string {
  if (s === 'submitted') return 'Offer submitted';
  return 'Draft';
}

/** Short label for dense tables — mirrors supplier portal: only Draft or Submitted. */
export function portalOfferStatusCompactLabel(s: PortalOfferStatus): string {
  if (s === 'submitted') return 'Submitted';
  return 'Draft';
}
